import { useEffect, useState } from "react";
import { isProbablyIpad } from "../utils/orientationLock";

// Screen size keeps tablet split views out; viewport width alone cannot do that.
export const getPhoneModes = (browserWindow) => {
  const disabled = { isPhoneNavigation: false, isPhoneBrowser: false, isPhonePwa: false };
  if (!browserWindow || !browserWindow.matchMedia) return disabled;
  const nav = browserWindow.navigator;
  const ua = nav.userAgent || "";
  const tablet = isProbablyIpad(browserWindow)
    || (/Android/i.test(ua) && !/Mobile/i.test(ua));
  const screen = browserWindow.screen;
  const shortSide = Math.min(screen.width || 0, screen.height || 0);
  const phone = !tablet && shortSide > 0 && shortSide < 600
    && browserWindow.innerWidth < 960
    && browserWindow.matchMedia("(hover: none) and (pointer: coarse)").matches;
  if (!phone) return disabled;
  const standalone = browserWindow.matchMedia("(display-mode: standalone)").matches || nav.standalone === true;
  const browser = !standalone && browserWindow.matchMedia("(display-mode: browser)").matches;
  return { isPhoneNavigation: browser || standalone, isPhoneBrowser: browser, isPhonePwa: standalone };
};

export default function usePhoneNavigation() {
  const [modes, setModes] = useState(() =>
    getPhoneModes(typeof window !== "undefined" ? window : null));
  useEffect(() => {
    const update = () => {
      const next = getPhoneModes(window);
      setModes(current => current.isPhoneNavigation === next.isPhoneNavigation
        && current.isPhoneBrowser === next.isPhoneBrowser && current.isPhonePwa === next.isPhonePwa ? current : next);
    };
    const media = ["(hover: none) and (pointer: coarse)", "(display-mode: browser)", "(display-mode: standalone)"]
      .map(query => window.matchMedia(query));
    update();
    window.addEventListener("resize", update);
    window.addEventListener("orientationchange", update);
    media.forEach(query => query.addEventListener ? query.addEventListener("change", update) : query.addListener(update));
    return () => {
      window.removeEventListener("resize", update);
      window.removeEventListener("orientationchange", update);
      media.forEach(query => query.removeEventListener ? query.removeEventListener("change", update) : query.removeListener(update));
    };
  }, []);
  useEffect(() => {
    const root = document.documentElement;
    root.toggleAttribute("data-phone-navigation", modes.isPhoneNavigation);
    root.toggleAttribute("data-phone-browser", modes.isPhoneBrowser);
    return () => {
      root.removeAttribute("data-phone-navigation");
      root.removeAttribute("data-phone-browser");
    };
  }, [modes.isPhoneNavigation, modes.isPhoneBrowser]);
  return modes;
}
